import { useSyncExternalStore } from 'react'
import { useRenderHistoryStore } from '@/stores/renderHistory.store'

const TICK_MS = 250

let tick = 0
let intervalId: ReturnType<typeof setInterval> | null = null
const listeners = new Set<() => void>()

function notify() {
  tick += 1
  listeners.forEach((l) => l())
}

function startTicker() {
  if (intervalId != null) return
  intervalId = setInterval(notify, TICK_MS)
}

function stopTicker() {
  if (intervalId == null) return
  clearInterval(intervalId)
  intervalId = null
}

function syncTickerToActiveCount(activeCount: number) {
  if (activeCount > 0 && listeners.size > 0) startTicker()
  else stopTicker()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  syncTickerToActiveCount(useRenderHistoryStore.getState().active.length)
  return () => {
    listeners.delete(listener)
    syncTickerToActiveCount(useRenderHistoryStore.getState().active.length)
  }
}

function getSnapshot() {
  return tick
}

useRenderHistoryStore.subscribe((state, prev) => {
  if (state.active.length !== prev.active.length) {
    syncTickerToActiveCount(state.active.length)
  }
})

/** Ticks every 250ms while active renders exist and a subscriber is mounted. */
export function useRenderElapsedTick(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

export function elapsedMs(startedAt: number, tick: number): number {
  void tick
  return Date.now() - startedAt
}
